interface IBybConditionalWrapper {
  condition: boolean;
  trueWrapper: (children: React.ReactNode) => React.ReactNode;
  falseWrapper?: (children: React.ReactNode) => React.ReactNode;
  children: React.ReactNode;
}

const BybConditionalWrapper = ({ condition, trueWrapper, falseWrapper, children }: IBybConditionalWrapper) => (
  <>{condition ? trueWrapper(children) : falseWrapper ? falseWrapper(children) : children}</>
);

export default BybConditionalWrapper;
